
import { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  CircularProgress
} from "@mui/material";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../../../components/BaseUrl";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { toast } from "react-hot-toast";
import { useFormik } from "formik";
import document1 from "../../../../assets/document1.svg"; // pdf icon
import { convertLocalDateTimeToUTC } from "../../../../components/dateTimeUtils";


const AddDocDrawer = ({ open, onClose,onSuccess  }) => {
  const { t } = useTranslation();
 const rawEncryptedToken = localStorage.getItem("token");
   const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
const [loading, setLoading] = useState(false);
const [uploadingPdf, setUploadingPdf] = useState(false);

  // Helper function to show validation errors
  const showError = (fieldName) => {
    return Boolean(
      formik.errors[fieldName] && 
      (formik.touched[fieldName] || formik.submitCount > 0)
    );
  };

  const formik = useFormik({
    initialValues: {
      docName: "",
      // category: [],
      subject: "",
      description: "",
      pdf: null,
      pdfUrl: null,
    },
    validate: (values) => {
      const errors = {};
      
      if (!values.docName?.trim()) {
        errors.docName = t("documents.validation.docNameRequired");
      }
      
      // if (!values.category || values.category.length === 0) {
      //   errors.category = t("documents.validation.categoryRequired");
      // }
      if (!values.subject?.trim()) {
   errors.subject = t("subjectRequired");

}
      
      if (!values.pdfUrl) {
        errors.pdf = t("documents.validation.pdfRequired");
      }
      
      return errors;
    },
    onSubmit: async (values) => {
      await handleSave(values);
    },
  });

  // Reset form when drawer closes
  useEffect(() => {
    if (!open) {
      formik.resetForm();
    }
  }, [open]);

  // Handle dropdown change
  const handleDropdownChange = ({ target: { name, value } }) => {
    formik.setFieldValue(name, value);
    formik.setFieldTouched(name, true);
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    formik.setFieldValue(name, value);
    formik.setFieldTouched(name, true);
  };

  // Handle PDF file change
  const handlePdfChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    if (file.type !== "application/pdf") {
      const message = t("documents.validation.pdfInvalidType");
      formik.setFieldError("pdf", message);
      formik.setFieldTouched("pdf", true, false);
      toast.error(message);
      return;
    }

    // Validate file size (10MB max)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      const message = t("documents.validation.pdfSizeExceeded");
      formik.setFieldError("pdf", message);
      formik.setFieldTouched("pdf", true, false);
      toast.error(message);
      return;
    }

    // Clear any previous errors
    formik.setFieldError("pdf", undefined);
    formik.setFieldValue("pdf", file);
    formik.setFieldTouched("pdf", true);

    // Upload PDF
    setUploadingPdf(true);
    try {
      const formData = new FormData();
      formData.append("pdf", file);

      const res = await fetch(`${BASE_URL}/upload/pdf`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await res.json().catch(() => null);

      if (!res.ok) throw new Error(data?.message || t("documents.uploadFailed"));

      const pdfUrl = data?.data?.url;

      formik.setFieldValue("pdfUrl", pdfUrl);
      // Always use the translated string here — the backend's message is
      // English-only, and for a plain success there's no extra information
      // in it worth losing localization over (unlike the failure path,
      // where the backend's specific reason is more useful than a generic
      // translated string).
      toast.success(t("documents.uploadSuccess"));
      console.log("✅ PDF uploaded successfully:", pdfUrl);
    } catch (err) {
      console.error("❌ Error uploading PDF:", err);
      const message = err.message || t("documents.uploadFailed");
      formik.setFieldError("pdf", message);
      formik.setFieldTouched("pdf", true, false);
      toast.error(message);
    } finally {
      setUploadingPdf(false);
    }
  };



  const handleSave = async (values) => {
    setLoading(true);
    console.log("💾 Saving document with values:", values);
    
  console.log("🟡 === SAVE DOCUMENT STARTED ===");
  console.log("🔐 Token:", token);
  console.log("📝 Form Values:", values);
    try {
      // prepare body
      const body = {
        name: values.docName,
        description: values.description,
        file_id: values.pdfUrl, // uploaded file url
        file_type: "pdf",
       subject: values.subject,
      };

      // Keep add payload UTC-safe for any datetime fields if added in future.
      const utcDateTimeKeys = ["uploaded_at", "created_at", "updated_at"];
      const normalizedBody = { ...body };
      utcDateTimeKeys.forEach((key) => {
        if (!normalizedBody[key]) return;
        const utcValue = convertLocalDateTimeToUTC(normalizedBody[key]);
        if (utcValue) normalizedBody[key] = utcValue;
      });

      console.log("📤 Final payload:", normalizedBody);

      const res = await fetch(`${BASE_URL}/documents/upload`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(normalizedBody),
      });

      const data = await res.json();
      if (!res.ok || data.error) {
        throw new Error(t("documents.uploadFailed"));
      }

      toast.success(t("documents.saveSuccess"));
      console.log("✅ Document saved:", data);
      if (onSuccess) onSuccess();
console.log("📡 Response Status:", res.status);
    console.log("📡 Response OK:", res.ok);
      formik.resetForm();
      onClose();
    } catch (err) {
      console.error("❌ Error saving document:", err);
      toast.error(t("documents.saveFailed"));
    } finally {
      setLoading(false);
    }
  };


  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 540,
          maxWidth: "100%",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.5,
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#f5f6f7",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 600,
              color: "#172B4D",
            }}
          >
            {t("common.uploadDocument") || "Upload Document"}
          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 3, flexGrow: 1, overflowY: "auto" }}>
        <CustomText
          sx={{
            ...textStyles.h1,
            fontSize: 18,
            fontWeight: 600,
            mb: 2,
            color: "#172B4D",
            textAlign: "left",
          }}
        >
          {t("addDocument.detailsHeading") || "Document Details"}
        </CustomText>

        {/* Doc Name */}
        <Box mb={2}>
          <label className="field_label">
            {t("addDocument.form.docName")} <span className="red_asterisk">*</span>
          </label>
          <input
            type="text"
            name="docName"
            value={formik.values.docName}
            onChange={handleChange}
            onBlur={formik.handleBlur}
            className="project_input"
            style={{ 
              width: "100%", 
              marginTop: 6, 
              height: "42px",
              borderColor: showError("docName") ? "#d32f2f" : undefined
            }}
          />
          {showError("docName") && (
            <CustomText sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
              {formik.errors.docName}
            </CustomText>
          )}
        </Box>

        {/* View Access as Radio */}
  


      

        {/* Category Dropdown */}
        {/* <Box mb={2}>
          <MultiSelectDropdown
            label={t("addDocument.form.category")}
            name="category"
            values={formik.values.category}
            onChange={handleDropdownChange}
            options={[
              { label: t("addDocument.categories.medical"), value: "medical" },
              { label: t("addDocument.categories.id"), value: "id" },
              { label: t("addDocument.categories.expense"), value: "expense" },
              { label: t("addDocument.categories.other"), value: "other" }
            ]}
          />
          {showError("category") && (
            <CustomText sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
              {formik.errors.category}
            </CustomText>
          )}
        </Box> */}

{/* Subject */}
<Box mb={2}>
  <label className="field_label">
   {t('documents.th.subject')} <span className="red_asterisk">*</span>
  </label>
  <input
    type="text"
    name="subject"
    value={formik.values.subject}
    onChange={handleChange}
    onBlur={formik.handleBlur}
    className="project_input"
    style={{
      width: "100%",
      marginTop: 6,
      height: "42px",
      borderColor: showError("subject") ? "#d32f2f" : undefined
    }}
  />
  {showError("subject") && (
    <CustomText sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
      {formik.errors.subject}
    </CustomText>
  )}
</Box>


        {/* Description */}
        <Box mb={2}>
          <label className="field_label">{t("addDocument.form.description")}</label>
          <textarea
            name="description"
            rows={4}
            className="project_input"
            style={{ width: "100%", marginTop: 6 }}
            value={formik.values.description}
            onChange={handleChange}
            onBlur={formik.handleBlur}
          />
        </Box>


  {/* PDF Upload */}
        <Box mb={2}>
          <CustomText
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              fontFamily: "Poppins, sans-serif",
              color: "#6B778C",
              display: "inline-block",
              marginBottom: "4px",
            }}
          >
            {t("addDocument.form.pdf")} <span className="red_asterisk">*</span>
          </CustomText>

          <Box
            sx={{
              border: showError("pdf") ? "2px dashed #d32f2f" : "2px dashed #D0D5DD",
              borderRadius: 2,
              p: 3,
              textAlign: "center",
              backgroundColor: "#F9FAFB",
              cursor: uploadingPdf ? "wait" : "pointer",
              mb: 1,
              height: 160,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              opacity: uploadingPdf ? 0.6 : 1,
            }}
          >
            {uploadingPdf ? (
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                <CircularProgress size={24} />
                <CustomText sx={{ fontSize: 14, fontWeight: 500 }}>
                  {t("common.uploading") || "Uploading..."}
                </CustomText>
              </Box>
            ) : !formik.values.pdf ? (
              <label htmlFor="pdf-upload" style={{ cursor: "pointer" }}>
                <input
                  type="file"
                  id="pdf-upload"
                  name="pdf"
                  accept="application/pdf"
                  onChange={handlePdfChange}
                  hidden
                />
                <CustomText sx={{ fontSize: 14, fontWeight: 500 }}>
                  {t("addDocument.form.dragDrop")}{" "}
                  <span style={{ textDecoration: "underline", color: "#006EC2" }}>
                    {t("addDocument.form.browse")}
                  </span>
                </CustomText>
              </label>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                {/* File Info */}
                <Box sx={{ textAlign: "center" }}>
                  <Box
                    component="img"
                    src={document1}
                    alt="PDF"
                    sx={{ width: 45, height: 45 }}
                  />
                  <CustomText
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#172B4D",
                      wordBreak: "break-word",
                    }}
                  >
                    {formik.values.pdf.name}
                  </CustomText>
                  <CustomText
                    sx={{
                      fontSize: 12,
                      fontWeight: 400,
                      color: "#6B778C",
                    }}
                  >
                    {(formik.values.pdf.size / (1024 * 1024)).toFixed(2)} MB
                  </CustomText>
                </Box>
              </Box>
            )}

            {/* ❌ Remove Icon */}
            {formik.values.pdf && !uploadingPdf && (
              <IconButton
                size="small"
                onClick={() => {
                  formik.setFieldValue("pdf", null);
                  formik.setFieldValue("pdfUrl", null);
                  formik.setFieldTouched("pdf", false);
                  formik.setFieldError("pdf", undefined);
                }}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  backgroundColor: "#fff",
                  border: "1px solid #E0E0E0",
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                <img src={profilecross} alt="remove" style={{ width: 20, height: 20 }} />
              </IconButton>
            )}
          </Box>
          {showError("pdf") && (
            <CustomText sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
              {formik.errors.pdf}
            </CustomText>
          )}
        </Box>





        {/* Save Button */}
        <CustomButton
          label={
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              {loading && <CircularProgress size={18} sx={{ color: "#fff", mr: 1 }} />}
              {t("common.save") || "Save"}
            </Box>
          }
          sx={{ mt: 2 }}
          onClick={formik.handleSubmit}
          size="small"
          disabled={loading || uploadingPdf}
        />
      </Box>
    </Drawer>
  );
};

export default AddDocDrawer;





